//TODO Add unit tests for this file
import { isBefore } from 'date-fns';
import { ANNUAL_STATEMENT_NOTIFICATION_KEY } from 'core/constants';
import {
	getLocalStorageItem,
	removeLocalStorageItem,
	setLocalStorageItem,
} from './localStorage';

export type AnnualStatementNotification = {
	id: string;
	accountNumber?: string;
	productName?: string;
	accessToken?: string;
	isDownLoaded?: boolean;
	isDismissed?: boolean;
	publishEndDate?: string;
	expired?: boolean;
};

const parseNotifications = (item: string): AnnualStatementNotification[] => {
	try {
		const parsedItem = JSON.parse(item);

		if (!Array.isArray(parsedItem)) {
			return [];
		}

		return parsedItem.filter(
			(notification): notification is AnnualStatementNotification =>
				typeof notification === 'object' &&
				notification !== null &&
				typeof notification.id === 'string',
		);
	} catch (error) {
		return [];
	}
};

export const AnnualStatementNotificationStore = {
	get(serverDateTime: Date): AnnualStatementNotification[] {
		const item = getLocalStorageItem(ANNUAL_STATEMENT_NOTIFICATION_KEY);

		if (item) {
			try {
				// This will cleanup the past dates versus the current date to avoid storing a lot of data in localStorage.
				// Will check for past dates and tag it as expired.
				const itemArray = JSON.parse(item)?.map(
					(i: AnnualStatementNotification) => ({
						...i,
						expired: isBefore(
							new Date(i.publishEndDate ?? new Date()),
							new Date(serverDateTime),
						),
					}),
				);

				// Filter those data which are not yet expired.
				const cleanUpArray =
					itemArray.filter(
						(c: AnnualStatementNotification) => c.expired === false,
					) ?? [];

				// Update localStorage
				setLocalStorageItem(
					ANNUAL_STATEMENT_NOTIFICATION_KEY,
					JSON.stringify(cleanUpArray),
				);

				return cleanUpArray;
			} catch (error) {
				return [];
			}
		}

		return [];
	},

	set(annualStatementNotification: AnnualStatementNotification) {
		const item = getLocalStorageItem(ANNUAL_STATEMENT_NOTIFICATION_KEY);
		const notifArray = item ? parseNotifications(item) : [];

		// Use a composite match (document id + account + product) to stay scoped on the selected account.
		// This prevents one account's action from overwriting another account when the same document id appears across accounts/products.
		// Applicable to multiple accounts data.
		const updatedNotifArray = notifArray.filter(
			(notification) =>
				!(
					notification.id === annualStatementNotification.id &&
					notification.accountNumber ===
						annualStatementNotification.accountNumber &&
					notification.productName ===
						annualStatementNotification.productName
				),
		);

		updatedNotifArray.push(annualStatementNotification);

		setLocalStorageItem(
			ANNUAL_STATEMENT_NOTIFICATION_KEY,
			JSON.stringify(updatedNotifArray),
		);
	},

	remove() {
		removeLocalStorageItem(ANNUAL_STATEMENT_NOTIFICATION_KEY);
	},
};
